import urlConfig, { SingleUrlConfig, UrlConfig } from '@root/url.config';
import { Configuration as RollbarConfiguration } from 'rollbar';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SERVER_ENV_ENUM {
  local = 'local',
  dev = 'dev',
  uat = 'uat',
  prd = 'prd',
}

const SERVER_ENV: SERVER_ENV_ENUM = (process.env.NEXT_PUBLIC_SERVER_ENV as SERVER_ENV_ENUM) || SERVER_ENV_ENUM.local;

interface Environment {
  name: string;
  devTools: boolean;
  rollbarActive: boolean;
}

interface Config extends Environment {
  environment: SERVER_ENV_ENUM;
  rollbar: RollbarConfiguration & { active?: boolean; serverAccessToken?: string };
  url: SingleUrlConfig;
  table: {
    pageSizeOptions: number[];
    advancedPaginationThreshold: number;
  };
}

const environment: Environment = {
  local: {
    name: 'local',
    devTools: true,
    rollbarActive: false,
  },
  dev: {
    name: 'dev',
    devTools: true,
    rollbarActive: false,
  },
  uat: {
    name: 'uat',
    devTools: true,
    rollbarActive: false,
  },
  prd: {
    name: 'prd',
    devTools: false,
    rollbarActive: false,
  },
}[SERVER_ENV];

const config: Config = {
  environment: SERVER_ENV,

  rollbar: {
    captureUncaught: true,
    captureUnhandledRejections: true,
    accessToken: process.env.NEXT_PUBLIC_ROLLBAR_KEY,
    environment: SERVER_ENV,
    payload: {
      environment: SERVER_ENV,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: process.env.NEXT_BUILD_ID,
          guess_uncaught_frames: true,
        },
      },
    },
    serverAccessToken: process.env.NEXT_ROLLBAR_SERVER_KEY,
    enabled: environment.rollbarActive,
  },
  table: {
    pageSizeOptions: [10, 15, 20, 25, 30, 40, 50],
    advancedPaginationThreshold: 3,
  },

  url: (urlConfig as UrlConfig)[SERVER_ENV],

  ...environment,
};

/* eslint-disable no-console */
console.log('================== ENV CONFIG ==================');
console.log(` SERVER_ENV : ${SERVER_ENV}`);
console.log('environment :', environment);
console.log('config :', config);
console.log('================================================');
/* eslint-enable no-console */

export default config;
